import React from 'react';

function Home() {
  return (
    <div className="home-minimal">
      <h1>RGNR Capital Partners</h1>
    </div>
  );
}

export default Home;
